import { Injectable } from '@angular/core';

import { DataService } from './data.service';
import { UserRolesService } from './user-roles.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderSearchEnabledService extends DataService<boolean> {
  constructor(private userRolesService: UserRolesService) {
    super();

    this.addSubscription(
      this.userRolesService.get$().subscribe(() => {
        const canUseSearch = this.userRolesService.isAdmin || this.userRolesService.isGroupAdmin;
        this.set(canUseSearch);
      })
    );
  }
}
